<template>
  <el-checkbox-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    @update:modelValue="update"
  >
    <el-checkbox-button
      v-for="option in options"
      :key="option.type_id"
      :value="option.type_id"
    >
      {{ option.label }}
    </el-checkbox-button>
  </el-checkbox-group>
  <el-select v-else v-model="value" multiple @update:modelValue="update">
    <el-option
      v-for="option in options"
      :key="option.type_id"
      :label="option.type_id"
      :value="option.type_id"
    >
      {{ option.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { CreativeStateLabels, CreativeState } from '@/api/types'
import useResize from '@/hooks/useResize'
import { NO_FUNDS_STATE } from '@/apps/traforama/constants'

export default defineComponent({
  name: 'CreativeStateSelector',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: any) {
      context.emit('update:modelValue', newValue)
    }
    // @ts-ignore: Object is possibly 'undefined'
    const options = Object.values(CreativeStateLabels).filter(
      (x) => x.type_id !== NO_FUNDS_STATE
    )

    const { isDesktop } = useResize()

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, isDesktop, options, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
}

:deep(.el-checkbox-button--medium .el-checkbox-button__inner) {
  padding: 9px;
}
</style>
